/* eslint-disable react/require-default-props -- defaults via destructuring; no defaultProps (React 19) */
import React from 'react';
import PropTypes from 'prop-types';

const VIEWBOX_SIZE = 13;
const DESIGN_STROKE_WIDTH = 1.08333;

const DOWNLOAD_TRAY_PATH =
  'M11.375 8.125V10.2917C11.375 10.8896 10.8896 11.375 10.2917 11.375H2.70833C2.11043 11.375 1.625 10.8896 1.625 10.2917V8.125';

const DOWNLOAD_ARROW_PATH = 'M6.49967 1.625V8.125M4.33301 5.95833L6.49967 8.125L8.66634 5.95833';

const iconPropTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

/**
 * Download / save (13×13, Figma u:download). Arrow down into tray, stroke style.
 * Pairs with UploadToTopIcon. Color via `currentColor`.
 * Distinct from DownloadIcon (18×18 fill) and DownloadToBottomIcon (16×20 fill).
 * Pass `aria-label` when the icon conveys meaning without adjacent text.
 */
const DownloadToTrayIcon = ({
  size = VIEWBOX_SIZE,
  stroke = 'currentColor',
  strokeWidth,
  className = '',
  'aria-label': ariaLabel,
  'aria-hidden': ariaHidden = true,
  ...props
}) => {
  const resolvedStrokeWidth = strokeWidth ?? (size * DESIGN_STROKE_WIDTH) / VIEWBOX_SIZE;

  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${VIEWBOX_SIZE} ${VIEWBOX_SIZE}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={['ds-icon', className].filter(Boolean).join(' ')}
      aria-hidden={ariaLabel ? undefined : ariaHidden}
      aria-label={ariaLabel || undefined}
      role={ariaLabel ? 'img' : undefined}
      focusable="false"
      {...props}
    >
      <path
        d={DOWNLOAD_TRAY_PATH}
        stroke={stroke}
        strokeWidth={resolvedStrokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d={DOWNLOAD_ARROW_PATH}
        stroke={stroke}
        strokeWidth={resolvedStrokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

DownloadToTrayIcon.propTypes = {
  ...iconPropTypes,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.number,
};

export { DownloadToTrayIcon };
export default DownloadToTrayIcon;
